// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/antd/dist/antd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./GorditaFonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./PoppinsFonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Ginto_Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Ringside-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Menlo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FONTS */

@font-face {
  font-family: "Ginto";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: "Ringside";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: "Menlo";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

/* BASE */
html, body {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  height: 100%;
  width: 100%;

  margin: 0;
  padding: 0;
  -moz-osx-font-smoothing: grayscale;
   -webkit-font-smoothing: antialiased;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

#root {
  height: 100%;
  width: 100%;
}

/* GENERIC */
.bg-dark {
  background-color: #1e1e1e;
  color: #ffffff;
}

/*****************
 * TURING HEADER
 *****************/
.turing-header {
  width: 100%;
  padding: 2.6rem;
}

.turing-header--layout-relative {
  position: relative;
}

.turing-header--layout-fixed {
  position: fixed;
}

.turing-header__title {
  font-weight: 600;
  cursor: pointer;
}

@media only screen and (min-width: 48rem) {
  .turing-header {
    padding: 3.2rem 3.6rem;
  }
}

@media only screen and (min-width: 64rem) {
  .turing-header {
    padding: 4.2rem 4.6rem;
  }
}


/*********************************
 * BUTTON Settings
 *********************************/
.btn {
  padding: .8rem;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;

  background: transparent;
  outline: none;
}

.btn .icon {
  margin-right: .5rem;
}

.btn--full {
  width: 100%;
}

.btn--rounded {
  border-radius: 2rem;
}

.btn--light {
  color: #202020;
  border-color: #d4d4d4;
  background-color: #ffffff;
}

.btn--light:hover,
.btn--light:active {
  color: #000000;
  background-color: #d4d4d4;
}

.btn--dark {
  color: #ffffff;
  border-color: #5a5a5a;
  background-color: #1e1e1e;
}

.btn--dark:hover,
.btn--dark:active {
  color: #ffffff;
  background-color: #5a5a5a;
}

/**********************************************************************
 * COLOR PALETTE
 *
 * [2019-01-29] CSS variables are not supported in all versions of IE
 * so I won't be using them here.
 * #569cd6 -- reserved word code color
 * #ce9178 -- string code color
 * #d4d4d4 -- normal code color
 * #608b4e -- green code color
 * #5a5a5a -- line number color (for code sample)
 * #1e1e1e -- dark background
 * #7e7e7e -- subtitle color
 * #202020 -- text on light
 * #ffffff -- text on dark
 *********************************************************************/


/*********************************************************************
 * ANIMATIONS
 *
 * Third-party library of CSS animations
 * https://github.com/daneden/animate.css
 *********************************************************************/

/* CUSTOM */

.i-display-n{ display: none !important; }

/* CUSTOM - END */

@media (prefers-reduced-motion) {
  .fadeOutDown,
  .fadeOut {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v3/assets/css/index.css"],"names":[],"mappings":"AAIA,UAAU;;AAEV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,+DAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+DAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,+DAAuD;AACzD;;AAEA,SAAS;AACT;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;;EAEX,SAAS;EACT,UAAU;EACV,kCAAkC;GACjC,mCAAmC;AACtC;;AAEA;;;EAGE,8BAA8B;KAC3B,2BAA2B;UACtB,sBAAsB;AAChC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;kBAEkB;AAClB;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;;kCAEkC;AAClC;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;;EAEf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;sEAcsE;;;AAGtE;;;;;sEAKsE;;AAEtE,WAAW;;AAEX,cAAc,wBAAwB,EAAE;;AAExC,iBAAiB;;AAEjB;EACE;;IAEE,UAAU;EACZ;AACF","sourcesContent":["@import '~antd/dist/antd.css';\n@import './GorditaFonts.css';\n@import './PoppinsFonts.css';\n\n/* FONTS */\n\n@font-face {\n  font-family: \"Ginto\";\n  font-display: swap;\n  src: url(../fonts/Ginto_Regular.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: \"Ringside\";\n  font-display: swap;\n  src: url(../fonts/Ringside-Medium.otf) format('truetype');\n}\n\n@font-face {\n  font-family: \"Menlo\";\n  font-display: swap;\n  src: url(../fonts/Menlo-Regular.ttf) format('truetype');\n}\n\n/* BASE */\nhtml, body {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  height: 100%;\n  width: 100%;\n\n  margin: 0;\n  padding: 0;\n  -moz-osx-font-smoothing: grayscale;\n   -webkit-font-smoothing: antialiased;\n}\n\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n}\n\n/* GENERIC */\n.bg-dark {\n  background-color: #1e1e1e;\n  color: #ffffff;\n}\n\n/*****************\n * TURING HEADER\n *****************/\n.turing-header {\n  width: 100%;\n  padding: 2.6rem;\n}\n\n.turing-header--layout-relative {\n  position: relative;\n}\n\n.turing-header--layout-fixed {\n  position: fixed;\n}\n\n.turing-header__title {\n  font-weight: 600;\n  cursor: pointer;\n}\n\n@media only screen and (min-width: 48rem) {\n  .turing-header {\n    padding: 3.2rem 3.6rem;\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  .turing-header {\n    padding: 4.2rem 4.6rem;\n  }\n}\n\n\n/*********************************\n * BUTTON Settings\n *********************************/\n.btn {\n  padding: .8rem;\n  border-width: 1px;\n  border-style: solid;\n  cursor: pointer;\n\n  background: transparent;\n  outline: none;\n}\n\n.btn .icon {\n  margin-right: .5rem;\n}\n\n.btn--full {\n  width: 100%;\n}\n\n.btn--rounded {\n  border-radius: 2rem;\n}\n\n.btn--light {\n  color: #202020;\n  border-color: #d4d4d4;\n  background-color: #ffffff;\n}\n\n.btn--light:hover,\n.btn--light:active {\n  color: #000000;\n  background-color: #d4d4d4;\n}\n\n.btn--dark {\n  color: #ffffff;\n  border-color: #5a5a5a;\n  background-color: #1e1e1e;\n}\n\n.btn--dark:hover,\n.btn--dark:active {\n  color: #ffffff;\n  background-color: #5a5a5a;\n}\n\n/**********************************************************************\n * COLOR PALETTE\n *\n * [2019-01-29] CSS variables are not supported in all versions of IE\n * so I won't be using them here.\n * #569cd6 -- reserved word code color\n * #ce9178 -- string code color\n * #d4d4d4 -- normal code color\n * #608b4e -- green code color\n * #5a5a5a -- line number color (for code sample)\n * #1e1e1e -- dark background\n * #7e7e7e -- subtitle color\n * #202020 -- text on light\n * #ffffff -- text on dark\n *********************************************************************/\n\n\n/*********************************************************************\n * ANIMATIONS\n *\n * Third-party library of CSS animations\n * https://github.com/daneden/animate.css\n *********************************************************************/\n\n/* CUSTOM */\n\n.i-display-n{ display: none !important; }\n\n/* CUSTOM - END */\n\n@media (prefers-reduced-motion) {\n  .fadeOutDown,\n  .fadeOut {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
